import { easasAxios } from "services/HttpService";
import { getEasasRestUrl } from "utils/utils";
import { ScadaProps } from "./scadaTypes";

export const IMAGE_UPLOAD_URL = '/EASAS/rest/images/upload';

export function getScadaImageUrl(scadaBackgroundId: number | undefined) {
    if (!scadaBackgroundId) return '';
    return getEasasRestUrl() + "/images/" + scadaBackgroundId;
}

export function getScadaData(identifiers: Array<string>, refTime?: string) {
    return easasAxios.post("/datasetData/dataInfoRecent", identifiers, {params: {refTime: refTime}})
        .then(res => res.data)
}

export function showCords(el: MouseEvent) {
    if (el.ctrlKey && window.isEditMode) {
        const tooltip = document.getElementById('simple-tooltip') as HTMLDivElement;
        const rect = (el.target as Element)!.getBoundingClientRect();

        const contWidth = rect.width;
        const contHeight = rect.height;
        const x = el.clientX,
            y = el.clientY;
        tooltip.style.top = y + 20 + 'px';
        tooltip.style.left = x + 20 + 'px';

        const relX = el.clientX - rect.left;
        const relY = el.clientY - rect.top;
        const pX = ((relX / contWidth) * 100).toFixed(2);
        const pY = ((relY / contHeight) * 100).toFixed(2);

        tooltip.textContent = `X:${pX}%, Y:${pY}%`;
        tooltip.style.display = 'block';
        tooltip.style.position = 'fixed';
    } else if (!el.ctrlKey || !window.isEditMode) {
        let tooltip = document.getElementById('simple-tooltip') as HTMLDivElement;
        tooltip.style.display = 'none';
    }
}

export 	const handleContextMenu = (e: MouseEvent, cb: () => void) => {
    let isEditMode = window.isEditMode;
    if (!isEditMode && window.scada.selectedLabels.length !== 0) {
        openScadaContextMenu(e, () => {
            cb();
        });
    }
    e.preventDefault();
};

export 	const cancelSelections = (e: MouseEvent) => {
    if (e.ctrlKey) return;

    if (new Date().getTime() - window.scada.lastClick < 500) return;

    for (const el of window.scada.selectedLabels) {
        el.children[0].classList.remove('selectedLabel');
    }

    window.scada.selectedLabels = [];
};

export const tempId = (data: ScadaProps) => `${data.scadaBackgroundId}-${data.refreshRate}-${data.maxDelayTimeUnit}-${data.maxDelayTime}`